module.exports = __webpack_public_path__ + "static/hr_service-a20000e9cb8993446708ea967395b2c1.webp";